<template>

  <tr>
    <td>&nbsp;</td>
    <td
      colspan="16"
      style="border-right: 2px solid #000;"
    ></td>
    <td colspan="5"></td>
  </tr>

</template>

<script>
import LongFormDataCell from "@/components/properties/evaluations/multifamily/LongFormDataCell.vue";

export default {
  components: {
    LongFormDataCell
  },

  props: {
    rowdata: {
      type: Object
    },
    label: {
      type: String
    }
  },

  data() {
    return {};
  },

  methods: {
    calculate() {
      this.$parent.calculate();
    }
  },

  mounted() {}
};
</script>

<style>
</style>
